import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';

import HomePageAutoDeliveryDcxSection from './HomePageAutoDeliveryDcxSection/HomePageAutoDeliveryDcxSection';
import HomePageAutoDeliverySection from './HomePageAutoDeliverySection/HomePageAutoDeliverySection';

const HomePageAutoDeliverySectionSwitcher = (props) => {
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    return isDcx ? <HomePageAutoDeliveryDcxSection {...props} /> : <HomePageAutoDeliverySection {...props} />;
};

export default HomePageAutoDeliverySectionSwitcher;
